export default "__VITE_ASSET__BHJwEJta__"